import { render, staticRenderFns } from "./ProgressReportYears.vue?vue&type=template&id=b1578b10&"
import script from "./ProgressReportYears.vue?vue&type=script&lang=js&"
export * from "./ProgressReportYears.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1578b10')) {
      api.createRecord('b1578b10', component.options)
    } else {
      api.reload('b1578b10', component.options)
    }
    module.hot.accept("./ProgressReportYears.vue?vue&type=template&id=b1578b10&", function () {
      api.rerender('b1578b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/graduationProgress/ProgressReportYears.vue"
export default component.exports